import "./ConfirmationBox.css";
import { MdClose } from "react-icons/md";

function ConfirmationBox({ children, setIsConfirmationBoxOpen }) {
  return (
    <div className="confirmation-box-container">
      <div className="confirmation-box">{children}<MdClose className="close" onClick={()=>setIsConfirmationBoxOpen(false)}/></div>
    </div>
  );
}

export default ConfirmationBox;
